import { Fragment } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import LayoutContainer from 'components/Common/LayoutContainer'
import BodyText from 'LuxKit/Typography/BodyText'
import LeLiveHeading from './LeLiveHeading'
import Divider from 'LuxKit/Divider'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import LeLiveHighlightCard from './LeLiveHighlightCard'
import LeLiveGetTicketsButton from './LeLiveGetTicketsButton'
import type { HighlightCardData } from './LeLiveHighlightCard'

const HIGHLIGHTS: Array<HighlightCardData> = [
  {
    id: 'highlight-marketplace',
    imageId: 'boftenzn8euv3cz2iz1g',
    title: 'A global travel marketplace',
    body: 'Meet 50+ premium travel partners including hotels, airlines, cruise lines and tourism boards showcasing their best offers.',
    presentedBy: 'PassportCard',
    presentedByLogoId: 'jnlxnrbgk10uiyhryeus',
    presentedByLogoHeight: 48,
  },
  {
    id: 'highlight-panels',
    imageId: 'zpl4oigz0cgfvwoqgcti',
    title: 'Live panels & guest speakers',
    body: 'Hear insider tips, emerging trends, and stories from travel industry leaders, destination experts, and celebrity guests.',
    presentedBy: 'Mastercard',
    presentedByLogoId: '9sz94m8h9agkc5dm9jp',
    presentedByLogoHeight: 48,
  },
  {
    id: 'highlight-offers',
    imageId: 'b3b1oc8djrym8blx6swk',
    title: 'Exclusive event-only offers',
    body: 'Unlock and book limited-time offers only available at Luxury Escapes Live.',
  },
  {
    id: 'highlight-sessions',
    imageId: '1gbsiveq9mos6bw92b5',
    title: 'One-on-one expert sessions',
    body: 'Chat face-to-face with Luxury Escapes travel specialists to access and bespoke recommendations for your next trip.',
  },
]

interface Props {
  hasRegistration: boolean
}

function LeLiveHighlights({ hasRegistration }: Props) {
  const intl = useIntl()

  return (
    <Sheet padding="40 20" desktopPadding="64 0" id="highlights">
      <LayoutContainer>
        <Group direction="vertical" gap={40} horizontalAlign="center">
          <Group direction="vertical" gap={8} horizontalAlign="center">
            <LeLiveHeading variant="heading1alt" as="h2" align="center">
              <FormattedMessage
                id="KvdE5NDpSRSkwj4qX6Gi"
                defaultMessage="Melbourne’s <em>unmissable</em> travel event"
                description="Highlights section heading with emphasis on unmissable"
                values={{
                  em: (chunks) => <em>{chunks}</em>,
                }}
              />
            </LeLiveHeading>
            <BodyText variant="medium" colour="neutral-two" align="center">
              {intl.formatMessage({
                id: '5PbuaPXUwj2ScS7XElAy',
                defaultMessage: 'Enjoy an immersive, experience-led event where inspiration, expertise and exclusive offers come together.',
                description: 'Highlights section subtitle describing the event experience',
              })}
            </BodyText>
          </Group>

          <Group
            direction="vertical"
            desktopDirection="horizontal"
            desktopHorizontalAlign="stretch"
            gap={16}
            desktopGap={24}
          >
            {HIGHLIGHTS.map((highlight, index) => (
              <Fragment key={highlight.id}>
                {index > 0 && (
                  <CSSBreakpoint max="tablet">
                    <Divider kind="primary" />
                  </CSSBreakpoint>
                )}
                <LeLiveHighlightCard data={highlight} />
              </Fragment>
            ))}
          </Group>

          <LeLiveGetTicketsButton hidden={hasRegistration} />
        </Group>
      </LayoutContainer>
    </Sheet>
  )
}

export default LeLiveHighlights
